module.exports = __webpack_public_path__ + "media/images/talent/feature01-1c900aeb9e11ee2a0b5ee674f72cea37.png";